import Badge from "@mui/material/Badge";
import TaskAltOutlinedIcon from "@mui/icons-material/TaskAltOutlined";

function TasksBadge({ count, tasks, setTaskAlert }) {
  return count > 0 ? (
    <>
      <Badge
        sx={{ "& .MuiBadge-badge": { fontSize: "0.8rem" } }}
        color="error"
        showZero={false}
        badgeContent={count}
      >
        <TaskAltOutlinedIcon />
      </Badge>
    </>
  ) : (
    <div></div>
  );
}

export default TasksBadge;
